import { Children, ReactNode } from 'react';

interface Props {
  currentStep: number; // 1-based
  children: ReactNode;
  testId?: string;
}

// Multi-step wizard container. Renders only the child at `currentStep` (1-based).
// Optionally shows a "Step N of M — Label" indicator above the active step.
export function StepWizard({ currentStep, children, testId }: Props) {
  const steps = Children.toArray(children);
  if (!testId) return <>{steps[currentStep - 1]}</>;
  return (
    <div data-testid={testId} style={{ display: 'contents' }}>
      <div data-testid={`wizard-step-${currentStep}`} style={{ display: 'contents' }}>{steps[currentStep - 1]}</div>
    </div>
  );
}
